import {useSelector} from 'react-redux';

import {useAbortableLoad} from "../../Hooks";
import "./style.css";
import DocsSecondRight from "../../old_components/DocsMain/DocsSecond/DocsSecondRight.jsx";
import ContentContainer from "../../Components/ContentContainer/ContentContainer.js";

import mapStateToProps from './mapStateToProps';
import {getCriteria} from '../../shared/helpers/getCriteria.js';

export const DocRz = () => {

    const {
        selectedGeoObjArray = [],
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate
    } = useSelector(mapStateToProps)


    const criteria = getCriteria(
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate,
    )

    const geoObjReport = useAbortableLoad(
        'getGeoObjReport',
        'geoObjReport',
        { objId: selectedGeoObjArray[0], criteria },
        selectedGeoObjArray?.length === 1,
        [selectedGeoObjArray, dateRangeCriteria, rangeStartDate, rangeEndDate],
        'setGeoObjReport'
    )
    const workingTimeSheet = useAbortableLoad(
        'getWorkingTimeSheet',
        'workingTimeSheet',
        {
            objIds: selectedGeoObjArray,
            criteria
        },
        selectedGeoObjArray?.length === 1,
        [selectedGeoObjArray, dateRangeCriteria, rangeStartDate, rangeEndDate],
        'setWorkingTimeSheet'
    )
    const geoObjVisits = useAbortableLoad(
        'getGeoObjVisits',
        'geoObjVisits',
        { id: selectedGeoObjArray[0], criteria },
        selectedGeoObjArray?.length === 1,
        [selectedGeoObjArray, dateRangeCriteria, rangeStartDate, rangeEndDate],
        'setObjVisits'
    )

    return (
        <ContentContainer
            content={(
                <DocsSecondRight
                    geoObjReport={geoObjReport}
                    workingTimeSheet={workingTimeSheet}
                    geoObjVisits={geoObjVisits}
                />
            )}
        />
    )

}
